import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import styles from './Button.module.scss';

type ButtonProps = {
  onClick?: VoidFunction;
  type?: 'primary' | 'secondary' | 'special';
  className?: string;
  style?: React.CSSProperties;
  loading?: boolean;
  disabled?: boolean;
} & PropsWithChildren;

export const Button = observer<ButtonProps>(
  ({
    onClick,
    children,
    type = 'primary',
    loading,
    disabled,
    className = '',
    style = {},
  }) => (
    <button
      onClick={onClick}
      style={style}
      disabled={disabled}
      className={clsx(styles.button, className, {
        [styles.loader]: loading,
        [styles[`loader-${type}`]]: loading,
        [styles[type]]: type,
      })}
    >
      {children}
    </button>
  ),
);
